import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { useTabs } from './use-tabs.js';
import s from './Tabs.module.scss.js';
var TabList = function TabList(_ref) {
  var children = _ref.children;
  var _useTabs = useTabs(),
    activeTab = _useTabs.activeTab,
    tabsRef = _useTabs.tabsRef;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    tabUnderlineWidth = _useState2[0],
    setTabUnderlineWidth = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    tabUnderlineLeft = _useState4[0],
    setTabUnderlineLeft = _useState4[1];
  useEffect(function () {
    var setTabPosition = function setTabPosition() {
      var _a, _b, _c;
      var currentTab = (_a = tabsRef.current) == null ? void 0 : _a[activeTab];
      setTabUnderlineLeft((_b = currentTab == null ? void 0 : currentTab.offsetLeft) != null ? _b : 0);
      setTabUnderlineWidth((_c = currentTab == null ? void 0 : currentTab.clientWidth) != null ? _c : 100);
    };
    setTabPosition();
    window.addEventListener("resize", setTabPosition);
    return function () {
      return window.removeEventListener("resize", setTabPosition);
    };
  }, [activeTab, tabsRef]);
  return /* @__PURE__ */jsxs("ul", {
    className: s.tabs__list,
    children: [children, /* @__PURE__ */jsx("span", {
      className: s.tabs__slider,
      style: {
        left: tabUnderlineLeft,
        width: tabUnderlineWidth
      }
    })]
  });
};
export { TabList };